export const UNLOCK_COST_SEQUENCE = [1, 2, 5, 10, 20, 50, 100];

/**
 * Returns the cost in reward points required to unlock a busted box
 * based on the global failure count.
 *
 * Failure 0 -> 1
 * Failure 1 -> 2
 * Failure 2 -> 5
 * Failure 3 -> 10
 * Failure 4 -> 20
 * Failure 5 -> 50
 * Failure 6+ -> 100
 */
export function getUnlockCost(failureCount: number): number {
  if (failureCount <= 0) return UNLOCK_COST_SEQUENCE[0];
  if (failureCount >= UNLOCK_COST_SEQUENCE.length) return 100;
  return UNLOCK_COST_SEQUENCE[failureCount];
}
